// Doit couvrir les languageId des combinaisons seedées (SupportedGeoLanguages).
export const LANGUAGE_NAMES = {
    '1000': 'EN',
    '1001': 'DE',
    '1002': 'FR',
    '1003': 'ES',
    '1004': 'IT',
    '1005': 'JA',
    '1009': 'DA',
    '1010': 'NL',
    '1011': 'FI',
    '1012': 'KO',
    '1013': 'NO',
    '1014': 'PT',
    '1015': 'SV',
    '1017': 'ZH-CN',
    '1018': 'ZH-TW',
    '1019': 'AR',
    '1020': 'BG',
    '1021': 'CS',
    '1022': 'EL',
    '1023': 'HI',
    '1024': 'HU',
    '1025': 'ID',
    '1027': 'HE',
    '1028': 'LV',
    '1029': 'LT',
    '1030': 'PL',
    '1032': 'RO',
    '1033': 'SK',
    '1034': 'SL',
    '1037': 'TR',
    '1039': 'HR',
    '1043': 'ET',
};

export const getLanguageName = (languageId) => {
    return LANGUAGE_NAMES[languageId] || languageId;
};
